<template>
  <div class="web-box-all" >
    <ext-header ref="ExtHeader" select_menu="0"></ext-header>

    <div class="web-home-main">
      <div class="web-goods-show-image">
        <div class="web-goods-show-image-left">
            <div class="web-goods-show-image-box">
                <div class="web-goods-show-image-show" v-if="image_type=='1'">
                    <div class="web-goods-show-image-show-img">
                        <img-zoom class="web-goods-show-image-show-img-img" :src="select_image" style="width:418px;height:418px;" />
                    </div>
                    <div class="web-goods-image-size" @click="open_image(select_image)">
                      <img src="@/assets/icon/size02.png"/>
                    </div>
                </div>
                <div class="web-goods-show-image-show" v-else>
                  <ext-video :options="videoOptions"></ext-video>
                </div>
                <div class="web-goods-show-image-nav">
                    <p class="left" @click="set_left()"><img src="@/assets/icon/left01.png"/></p>
                    <ul :class="[get_left==1 ? 'left' : 'right']">
                        <li v-for="(vo,index) in img_list" :key="index" v-on:mouseover="set_image(web_url+vo.image,'1')">
                          <img src="@/assets/goods_load.png" v-real-img="web_url+vo.image"/>
                        </li>
                        <li v-if="(goods_info.flv_url)" style="position: relative;" v-on:mouseover="set_image(web_url+goods_info.flv_img,'2')">
                          <img v-if="goods_info.flv_url" src="@/assets/goods_load.png" v-real-img="web_url+goods_info.flv_img"/>
                          <img style="width:30px; height:30px; position: absolute; top:15px; left:15px;" src="@/assets/goods_show_07.png"/>
                        </li>
                    </ul>
                    <p class="right" @click="set_right()"><img src="@/assets/icon/right01.png"/></p>
                </div>
            </div>
        </div>
        <div class="web-goods-show-image-right">
          <div class="web-goods-show-txt">
            <h2>
              <span>{{goods_info.goods_remark}}</span>
            </h2>
            <p><i>¥</i><b>{{goods_info.goods_money}}</b></p>
            <ul>
              <li>
                <b>库存</b>
                <span v-if="goods_info.goods_qty=='0'">暂缺，接受下单预订，货到即发</span>
                <span v-else>充足</span>
              </li>
              <li><b>产品编号</b><span>{{goods_info.goods_no}}</span></li>
              <li v-if="pdf_list.length>0">
                  <b>产品文件</b>
                  <span>
                    <a v-for="(vo,index) in pdf_list" :key="index" @click="get_file_url(vo.type_name,vo.file_url)">{{vo.file_name}}</a>
                  </span>
                </li>
            </ul>
            <div class="web-goods-show-cart">
              <div class="web-goods-show-cart-left">
                <h4>
                  <b class="del" @click="goods_del()">-</b>
                  <b class="num">
                    <input type="number" v-model.number="goods_qty" oninput="if(value.length>3)value=value.slice(0,3)" />
                  </b>
                  <b class="add" @click="goods_add()">+</b>
                  <b class="cart" style="background:#fd9202" @click="add_cart(goods_info.goods_no)">加入购物车</b>
                  <b class="cart" @click="order_submit(goods_info.goods_no)">立即购买</b>
                </h4>
              </div>
            </div>
            <div class="web-goods-show-server">
              <p @click="add_collect()">
                <img v-if="collect_state==true" src="@/assets/icon/love01.png"/>
                <img v-else src="@/assets/icon/love02.png"/>
                <b>收藏商品</b>
              </p>
              <p style="display: none;">
                <img src="@/assets/icon/kf.png"/>
                <b>客服电话：</b>
              </p>
            </div>
            <div class="web-goods-show-remark">
              <p>{{goods_info.goods_activity}}</p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="web-home-main" v-if="explosive_view.image">
      <div class="web-home-title">
        <a></a>
        <p>为您准备的可拆分购买需求<i></i></p>
        <a></a>
      </div>
    </div>

    <div class="web-goods-main" v-if="explosive_view.image">
      <div class="web-app-goods-show-feature-box">
        <img class="bg" :src="web_url+explosive_view.image"/>
        <img v-for="(vo,index) in explosive_view.list" :key="index"  @click="get_goods_show(vo.goods_no)" class="link" :style="'width:'+(parseInt(68)*3)+'px; height:'+(parseInt(52)*3)+'px; left:'+(parseInt(vo.left)*3)+'px; top:'+(parseInt(vo.top)*3)+'px'" :tap="vo.top" src="@/assets/icon/click_gif.gif"/>
      </div>
    </div>

    <div class="web-home-main">
      <div class="web-home-title">
        <a></a>
        <p>为您推荐<i></i></p>
        <a></a>
      </div>
    </div>
    <div class="web-goods-main">
      <div class="web-home-goods">

        <div v-for="(vo,index) in recommend_list" :key="index" @click="get_goods_show(vo.goods_no)" :class="[vo.select==1 ? 'web-home-goods-list active' : 'web-home-goods-list']" v-on:mouseover="changeActive(index,'recommend_list')" v-on:mouseout="removeActive(index,'recommend_list')">
          <div :class="[vo.select==1 ? 'web-home-goods-list-data active' : 'web-home-goods-list-data']">
            <img src="@/assets/goods_load.png" v-real-img="web_url+vo.goods_image">
            <h2>{{vo.goods_name}}</h2>
            <h3>{{vo.goods_no}}</h3>
            <p>
              <i>¥</i><b>{{vo.goods_money}}</b>
            </p>
          </div>
        </div>

      </div>

    </div>

    <div class="web-home-line"></div>

    <ext-footer></ext-footer>

    <div v-if="image_state" class="web-goods-image-box" :style="[{width:img_width},{height:img_height},{'margin-left':img_margin}]">
      <img :src="select_image"/>
      <img @click="close_image()" class="close" src="@/assets/icon/size01.png"/>
    </div>

    <ext-toast :style="toast_state" :toast_text="toast_text"></ext-toast>

  </div>
</template>
<script>
import ExtHeader from '@/components/header/index'
import ExtFooter from '@/components/footer/index'
import {getUserId, ajax, Encrypt, Decrypt, webUrl} from '@/utils/extend'
import $ from 'jquery'
import ImgZoom from 'ht-image-zoomer'
import Toast from '@/components/toast/index'
import ExtVideo from '@/components/video/goods'

export default {
  name: 'goods_show',
  components: {
    'ext-header': ExtHeader,
    'ext-footer': ExtFooter,
    'img-zoom': ImgZoom,
    'ext-toast': Toast,
    'ext-video': ExtVideo
  },
  data () {
    return {
      title: '商品详情',
      zoomed: false,
      web_url: webUrl(),
      imageAspectRatio: 1,
      select_image: webUrl() + '/static/image/goods_load.png',
      get_left: 1,
      goods_qty: 1,
      goods_no: '',
      goods_info: {},
      recommend_list: [],
      img_list: [],
      pdf_list: '',
      collect_state: '',
      goods_auto_iamge: [],
      explosive_view: {
        image: ''
      },
      img_width: '0',
      img_height: '0',
      img_margin: '',
      image_state: false,
      imgsList: 'https://img-home.csdnimg.cn/images/20201124032511.png',
      toast_state: 'display:none',
      toast_text: '',
      image_type: '1',
      videoOptions: {
        width: 740,
        autoplay: 'false', // 自动播放
        controls: true, // 用户可以与之交互的控件
        loop: true, // 视频一结束就重新开始
        muted: false, // 默认情况下将使所有音频静音
        aspectRatio: '16:9', // 显示比率
        fullscreen: {
          options: {navigationUI: 'hide'}
        },
        sources: [
          {
            src: '',
            type: 'video/mp4'
          }
        ]
      }
    }
  },
  mounted () {
    var params = this.$route.query
    this.goods_no = Decrypt(params.v)
    this.load_data()

    var winWidth = $(window).height() * 0.9

    this.img_width = winWidth + 'px'
    this.img_height = winWidth + 'px'
    this.img_margin = '-' + (winWidth / 2) + 'px'
  },
  methods: {
    toast (msg) {
      var that = this
      that.toast_state = 'display:block'
      that.toast_text = msg
      setTimeout(function () {
        that.toast_text = ''
        that.toast_state = 'display:none'
      }, 1000)
    },
    add_collect () {
      var that = this
      var goodsId = this.goods_info.id
      var collectState = this.collect_state
      if (collectState === 1) {
        this.collect_state = 0
        ajax({
          url: '/store/goods/goods_collect',
          method: 'post',
          data: {
            uid: getUserId(),
            goods_id: goodsId,
            collect_type: 2
          }
        }, function (ret) {
        })
      } else {
        this.collect_state = 1
        ajax({
          url: '/store/goods/goods_collect',
          method: 'post',
          data: {
            uid: getUserId(),
            goods_id: goodsId,
            collect_type: 1
          }
        }, function (ret) {
        })
      }
    },
    get_goods_show (goodsNo) {
      // let routeData = this.$router.resolve({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
      // window.open(routeData.href, '_blank')
      this.$router.push({path: '/goods/goods_show', query: {v: Encrypt(goodsNo)}})
    },
    get_file_url (type, url) {
      var webUrl = this.web_url
      window.open(webUrl + url, '_blank')
    },
    set_image (img, type) {
      this.select_image = img
      this.image_type = type
    },
    set_left () {
      this.get_left = 1
    },
    set_right () {
      this.get_left = 2
    },
    onImageLoad (e) {
      const img = e.target
      this.imageAspectRatio = img.naturalWidth / img.naturalHeight
    },
    changeActive (index, list) {
      this.$set(this['' + list][index], 'select', '1')
    },
    removeActive (index, list) {
      this.$set(this['' + list][index], 'select', '0')
    },
    goods_add () {
      var qty = this.goods_qty ? this.goods_qty : 1
      if (qty < 999) {
        qty = qty + 1
      } else {
        qty = 999
      }
      this.goods_qty = qty
    },
    goods_del () {
      var qty = this.goods_qty ? this.goods_qty : 1
      if (qty > 1) {
        qty = qty - 1
      } else {
        qty = 1
      }
      this.goods_qty = qty
    },
    order_submit (goodsNo) {
      var that = this

      ajax({
        url: '/store/order/add_cart',
        method: 'post',
        data: {
          uid: getUserId(),
          pay_goods: 'pay_goods',
          type_id: '2',
          goods_no: goodsNo,
          qty: '1'
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          var selectIds = ret.data.cart_id
          that.$router.push({path: '/cart/order_submit', query: {v: Encrypt(selectIds), type_id: '2'}})
        } else {
          that.toast(ret.msg)
        }
      })
    },
    add_cart (goodsNo) {
      var that = this
      var qty = this.goods_qty

      ajax({
        url: '/store/order/add_cart',
        method: 'post',
        data: {
          uid: getUserId(),
          type_id: 1,
          type_add: 'add',
          goods_no: goodsNo,
          qty: qty
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.toast(ret.msg)
          that.$refs.ExtHeader.load_cart_list()
        } else {
          that.toast(ret.msg)
        }
      })
    },
    open_image (img) {
      this.image_state = true
    },
    close_image () {
      this.image_state = false
    },
    load_data () {
      var that = this
      var goodsNo = this.goods_no
      var webUrl = this.web_url
      ajax({
        url: '/store/goods/goods_show_json',
        method: 'post',
        data: {
          uid: getUserId(),
          goods_no: goodsNo
        }
      }, function (ret) {
        if (ret && ret.code === 'success') {
          that.goods_info = ret.data
          that.pdf_list = ret.data.pdf_list
          that.collect_state = ret.data.collect_state
          var imgList = ret.data.img_list
          that.goods_auto_iamge = ret.data.explosive_img
          that.explosive_view = ret.data.explosive_view

          if (ret.data.flv_url) {
            that.videoOptions.sources[0].src = webUrl + ret.data.flv_url
          }

          that.img_list = imgList

          that.select_image = webUrl + imgList['0'].image

          var imgurl = webUrl + imgList['0'].image

          var img = new Image()
          img.src = imgurl
          img.onload = function () {
            var ww = img.width
            var hh = img.height
            // console.log(ww + '/' + hh)
          }

          ajax({
            url: '/store/goods/goods_recommend_json',
            method: 'post',
            data: {
              uid: getUserId(),
              goods_no: goodsNo,
              recommend_nos: ret.data.recommend_nos
            }
          }, function (rrr) {
            if (rrr && rrr.code === 'success') {
              that.recommend_list = rrr.data
            }
          })
        } else {
          that.class_list = []
        }
      })
    }
  }
}
</script>
<style scoped>
header,section,footer,div,ul,ol,li,img,a,span,em,del,legend,center,strong,var,fieldset,form,label,dl,dt,dd,cite,input,hr,time,mark,code,figcaption,figure,textarea,h1,h2,h3,h4,h5,h6,p{
    display:-moz-box;
    display: box;
    display: -webkit-box;
    font-family: "Noto Sans SC";
    display: inline-flex;
}

a { text-decoration:none; }

input { box-sizing:border-box;outline:none;}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {-webkit-appearance: none;}
input[type='number'] {-moz-appearance: textfield;}

.web-box-all { width:100%; height:auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-main { width:1000px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}
.web-home-line { width:100%; height:70px; }

.web-goods-show-image { width:1000px; height:auto; margin-top:20px; flex-flow:row;  justify-content:flex-start;}
    .web-goods-show-image-left { width:420px; height:auto; margin-right:30px;}
        .web-goods-show-image-box { width:420px; height:auto; flex-wrap:wrap; align-content:flex-start;}
            .web-goods-show-image-show { width:420px; height:420px; position: relative; border:1px solid #f2f2f2;}

              .web-goods-image-size { width:50px; height:50px; cursor: pointer; position: absolute; z-index: 99; right:0px; bottom:0px; background: #ffffff;}
                .web-goods-image-size img { width:32px; height:32px; margin:9px;}
            .web-goods-show-image-nav { width:420px; height:65px; overflow: hidden; position: relative; margin-top:5px; flex-flow:row; justify-content:flex-start; position: relative;}
                .web-goods-show-image-nav p { width:65px; height:65px; cursor: pointer; z-index: 99; position: absolute; background:#ffffff}
                .web-goods-show-image-nav p.left { width:65px; height:65px; left:0px; top:0px;}
                .web-goods-show-image-nav p.right { width:65px; height:65px; right:0px; top:0px;}
                .web-goods-show-image-nav p img { width:45px;  height:45px; margin:10px;}
                .web-goods-show-image-nav ul { width:660px; height:65px; position: absolute; z-index: 88; overflow: hidden; list-style:none; padding:0px;flex-flow:row;}
                .web-goods-show-image-nav ul.left { left:65px; top:0px;  justify-content:flex-start;}
                .web-goods-show-image-nav ul.right { right:65px; top:0px;  justify-content:flex-end;}
                .web-goods-show-image-nav ul li { width:65px; height:65px; cursor: pointer; padding:0px; box-sizing: border-box; margin-right:5px; border:1px solid #f2f2f2;}
                .web-goods-show-image-nav ul li img { width:63px; height:63px; object-fit: cover; }
                .web-goods-show-image-nav ul li:hover { border:1px solid #d81e06;}
    .web-goods-show-image-right { width:550px; height:auto;}

    .web-goods-show-txt { width:100%; height:auto; float:left; flex-wrap:wrap; align-content:flex-start;}
      .web-goods-show-txt h2 { width:100%; height:auto; line-height:20px; margin-top:30px; flex-flow:row; justify-content:flex-start; }
      .web-goods-show-txt h2 b { width:60px; height:22px; line-height:22px; border-radius: 2px; float:left; margin-right:5px; margin-top:11px; text-align: center; font-size:16px; font-weight: normal; background: #d81e06; color:#ffffff;}
      .web-goods-show-txt h2 span {  height:auto; word-break: break-all; word-wrap: break-word; white-space: pre-wrap; width:550px; line-height:30px;  display: block; margin-top:10px; margin-bottom:10px;  font-size:26px; color:#333333;font-weight: bold;}
      .web-goods-show-txt p { width:100%; height:60px; margin-top:0px; position: relative; overflow: hidden; line-height:80px; padding:0px; background: #ffffff;margin-right: 5px;}
      .web-goods-show-txt p i { font-size:24px; color:#ef290f;font-style: normal;}
      .web-goods-show-txt p b { font-size:38px; font-weight: normal; color:#ef290f;}
      .web-goods-show-txt p a { position: absolute; right:-20px; top:-40px; width: 210px;height: 180px;position: absolute;text-align: center; background: #d81e06;-webkit-transform: rotate(20deg);-moz-transform: rotate(20deg); filter: progid:DXImageTransform.Microsoft.BasicImage(Rotation=0.45);}
      .web-goods-show-txt ul { width:100%; height:auto; list-style:none; margin:0px 0px 0px 0px; padding:0px; flex-wrap:wrap; align-content:flex-start;}
      .web-goods-show-txt ul li { width:100%; height:30px; line-height:30px; margin-top:10px; padding:0px;flex-flow:row;  justify-content:flex-start;}
      .web-goods-show-txt ul li b { width:80px; font-size:16px; color:#999999; float:left;}
      .web-goods-show-txt ul li span { font-size:16px; color:#666666;}
      .web-goods-show-txt ul li span a { padding:0px 8px; height:30px; cursor: pointer; line-height:30px; margin:0px 5px; font-size:12px; border:1px solid #cccccc; color:#666666;}

  .web-goods-show-cart { width:100%; height:auto; margin-top:40px; flex-flow:row; justify-content:flex-start; background: #ffffff;}
    .web-goods-show-cart-left { width:90px; height:45px; position: relative;}
      .web-goods-show-cart p { width:80px; height:45px; border:1px solid #cccccc; position: relative; padding:0px; margin:0px; background: #ffffff; flex-flow:row; justify-content:flex-start;}
        .web-goods-show-cart p input { width:70px; height: 30px; line-height:30px; text-align: center; margin:7px 0px 0px 5px; border:0px; padding:0px; max-height:30px;}
        .web-goods-show-cart p b { width:20px; height:23px; cursor: pointer; margin:0px; padding: 0px; text-align: center; font-size:16px; color:#333333; border-left:1px solid #cccccc; position: absolute;}
        .web-goods-show-cart p b.add { width:20px; height:23px; line-height:21px; background: #f1f1f1; right:0px; top:0px; border-bottom:1px solid #cccccc;}
        .web-goods-show-cart p b.del { width:20px; height:23px; line-height:18px; background: #f1f1f1; right:0px; top:23px;}
    .web-goods-show-cart-right {  width:auto; height:45px; flex-flow:row; justify-content:flex-start;}
      .web-goods-show-cart-right a { width:140px; height:45px; cursor: pointer; line-height:45px; font-size: 16px; color:#ffffff; text-align: center; margin-right:15px; justify-content:center;}
      .web-goods-show-cart-right a.cart { background: #d81e06;}
      .web-goods-show-cart-right a.order {background: #d81e06;}

    .web-goods-show-server { width:100%; height:30px; margin-top:40px; border-top:1px dashed #cccccc; flex-flow:row; justify-content:flex-start;}
      .web-goods-show-server p { width:auto; height:30px; cursor: pointer; margin:10px 15px 0px 0px; padding:0px; background: #ffffff; line-height:30px; flex-flow:row; justify-content:flex-start;}
      .web-goods-show-server p img { width:16px; height:16px; margin-top:9px; margin-right:5px;}
      .web-goods-show-server p b { font-size: 12px; font-weight: normal; color:#666666;}

  .web-app-goods-show-feature-box { width:100%; height:auto; position: relative;  margin-top:15px;}
    .web-app-goods-show-feature-box img { width:960px; height:auto;}
    .web-app-goods-show-feature-box img.bg { width:960px; height:auto;}
    .web-app-goods-show-feature-box img.link { width:68px; height:52px; cursor: pointer; position: absolute; left:100px; top:0px;}

/*
推荐产品
*/
.web-goods-main { width:1020px; height:auto; margin:0px auto; flex-wrap:wrap; align-content:flex-start;}

.web-home-title { width:100%; height:50px; position: relative; flex-flow:row; justify-content:center; display: flex; margin-top:15px;}
  .web-home-title a { width:100px; height:10px; background: url('https://parts.franke.cn/static/image/line001.png') repeat-x; margin-top:22px; flex:1;}
  .web-home-title p { width:auto; padding:0px 15px; position: relative; box-sizing: border-box; height:50px; line-height: 50px; font-size:24px; color:#333333; text-align: center; justify-content:center;}
  .web-home-title p i { width:24px; height:1px; border-top:3px solid #d81e06; position: absolute; bottom:0px; left:50%; margin-left:-12px;}
  .web-home-title b { width:80px; cursor: pointer; height:50px; text-align: right; font-weight: normal; line-height:50px; font-size:12px; background: #ffffff; color:#666666; position: absolute; right: 0px; top:0px;}

.web-home-goods { width:100%; height:auto; margin-top:10px; display: flex; flex-flow:row; align-content:flex-start; flex-wrap:wrap;}
  .web-home-goods-list { width:255px; height:370px; margin:5px 0px; padding:10px; border:1px solid #ffffff;}
  .web-home-goods-list.active { border:1px solid #d81e06;}
  .web-home-goods-list-data { width:233px; height:350px; cursor: pointer; border:1px solid #e7e7e7; flex-wrap:wrap; align-content:flex-start;}
  .web-home-goods-list-data.active { border:1px solid #ffffff;}
  .web-home-goods-list-data img { width:100%; height:230px; padding:10px 10px 0px 10px;}
  .web-home-goods-list-data h2 { width:223px; height:40px;  word-break:break-all; display:-webkit-box;text-overflow:ellipsis; overflow:hidden; -webkit-line-clamp: 2; -webkit-box-orient:vertical; line-height:20px; margin:5px 0px; font-size:14px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data h3 { width:233px; height:20px; line-height:20px; margin:0px; font-size:12px; color:#333333; padding:0px 10px;}
  .web-home-goods-list-data p { width:233px; height:40px; padding:0px 10px; margin:0px; flex-flow:row; align-content:flex-start;}
  .web-home-goods-list-data p i { font-size:12px; margin-right:5px; margin-top:10px; font-style:normal; color:#d81e06;}
  .web-home-goods-list-data p b { font-size:22px; color:#d81e06;}

  .web-goods-show-cart-left h4 { width:298px; height:40px; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; position: absolute; left:15px; bottom: 10px; z-index: 99; margin:0px; padding:0px 10px; flex-flow:row; align-content:flex-start;}
  .web-goods-show-cart-left h4 b { font-size:14px; line-height:40px; float:left; font-weight: normal;}
  .web-goods-show-cart-left h4 b.del { width:30px; height:40px; cursor: pointer; line-height:35px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-goods-show-cart-left h4 b.num { width:44px; height:40px; overflow: hidden; border-top:1px solid #e7e7e7; border-bottom:1px solid #e7e7e7;}
  .web-goods-show-cart-left h4 b.num input { width:44px; height:30px; margin-top:5px; text-align: center; line-height:30px; font-size:12px; color:#333333; min-height:20px; border:0px;}
  .web-goods-show-cart-left h4 b.add { width:30px; height:40px; cursor: pointer; line-height:35px; text-align: center; color:#666666; font-size:20px; border:1px solid #e7e7e7;}
  .web-goods-show-cart-left h4 b.cart { width:90px; height:40px; cursor: pointer; margin-left:8px; text-align: center; line-height:40px; background: #d81e06; font-size:13px; color:#ffffff;}

  .web-goods-image-box { width:500px; height:500px; position: fixed; left:50%; margin-top:50px; z-index: 99999; background: #ffffff; border:8px solid #eeeeee;}
    .web-goods-image-box img { width:100% !important; height:100% !important; float:left;}
    .web-goods-image-box img.close { width:40px !important; height:40px !important; position: absolute; cursor: pointer; right:10px; top:10px;}

  .web-goods-show-remark { width:100%; height:auto; margin-top:25px;}

    .web-goods-show-remark p { width:100%; line-height: 22px; font-weight: bold; font-size:18px; color:rgb(253, 146, 2);}
</style>
<style>
  .zoom-preview { z-index: 999999 !important;}
  .web-goods-show-image-show-img { width:418px; height:418px; cursor:crosshair; }
  .vh--message-bottom { background: rgb(0, 0, 0,0) !important;}
  .web-goods-show-image-show-img-img { width:418px !important; height:418px !important;max-width:418px; max-height:418px; object-fit: cover;}
</style>



// WEBPACK FOOTER //
// src/pages/goods/goods_show.vue